import { API_PREFIX_BLOCK_CONTENT_PATH } from "@/constants/prefix-path-api"
import { HttpClient } from "../../../../app/api/HttpClient"
import { StrapiResponse } from "../../../../lib/config/types"
import { BlockContentResponse } from "../config/types"

export const useUiBuilder = () => {
  const fetchBlockContent = async (id: string) => {
    return await HttpClient.get<BlockContentResponse>(`/api/block-contents/${id}?populate=*`)
  }

  const saveBlockContent = async (id: string, data: JSON) => {
    return await HttpClient.put(`${API_PREFIX_BLOCK_CONTENT_PATH}/${id}`, {
      data: {
        content: JSON.stringify(data),
      },
    })
  }

  const createNewBlockContent = async (data: any): Promise<StrapiResponse<{ id: string }> | null> => {
    return await HttpClient.post(API_PREFIX_BLOCK_CONTENT_PATH, {
      data: {
        content: null,
        ...data,
      },
    })
  }

  const fetchBlockContentTemplate = async () => {
    return await HttpClient.get<BlockContentResponse>(
      `/api/block-contents?populate=*&filters[isTemplate][$eq]=true&pagination[pageSize]=100`,
    )
  }

  type RevalidateType = "pageSlug" | "postSlug" | "categoryId" | string

  const triggerRevalidate = async (typeRevalidate: { name: RevalidateType; value: string }) => {
    const apiTrigger = process.env.NEXT_PUBLIC_REVALIDATE_URL
    const API_PREFIX_REVALIDATE = `${apiTrigger}?${typeRevalidate.name}=${typeRevalidate.value}`

    return await fetch(`${API_PREFIX_REVALIDATE}`)
  }

  return {
    fetchBlockContent,
    saveBlockContent,
    createNewBlockContent,
    fetchBlockContentTemplate,
    triggerRevalidate,
  }
}
